import emailjs from "@emailjs/browser";

export const sendOrderNotifications = async (orderDetails, paymentResponse) => {
  try {
    // Format order items for email
    const formattedItems = orderDetails.items
      .map((item) => `${item.name} (${item.quantity}x) - GHS ${item.price}`)
      .join("\n");

    const formattedItemsHtml = orderDetails.items
      .map(
        (item) =>
          `<li><strong>${item.name}</strong> &times; ${item.quantity} — GHS ${item.price}</li>`
      )
      .join("");

    // EmailJS notification
    const emailTemplate = {
      order_number: orderDetails.orderNumber,
      customer_name: orderDetails.shippingAddress.name,
      customer_email: orderDetails.email,
      total: orderDetails.total,
      payment_method: orderDetails.paymentMethod,
      recipient_name: orderDetails.shippingAddress.name,
      phone_number: orderDetails.shippingAddress.phone,
      shipping_address: orderDetails.shippingAddress.street,
      city: orderDetails.shippingAddress.city,
      delivery_instructions:
        orderDetails.deliveryInstructions || "Standard Delivery",
      order_items: formattedItems,
      order_items_html: `<ul>${formattedItemsHtml}</ul>`,
      payment_reference: paymentResponse.reference,
    };

    console.log("Sending email with template:", emailTemplate); // Debug log

    const response = await emailjs.send(
      "service_fsryuvf",
      "template_bxjn8r9",
      emailTemplate,
      "qfVnFtZHSAmh2zLrX"
    );

    console.log("Email sent successfully:", response);
    return response;
  } catch (error) {
    console.error("Failed to send email notification:", error);
    throw error; // Re-throw to handle in the checkout component
  }
};
